import { Component, inject, signal } from '@angular/core';
import { DemoService } from './demo.service';

/**
 * El aviso fijo mientras dura el demo (textos de ECM). «Salir del demo» deja el equipo como estaba y recarga en el
 * login: recargar es la única forma de que no quede en memoria nada del demo (catálogo, clientes, la orden a medias).
 */
@Component({
  selector: 'app-aviso-del-demo',
  standalone: true,
  template: `
    @if (activo()) {
      <div class="demo-aviso" role="status" data-testid="aviso-del-demo">
        <span>Estás en el demo: nada de esto llega a un negocio.</span>
        <button type="button" class="demo-salir" (click)="salir()" [disabled]="saliendo()"
          data-testid="salir-del-demo">Salir del demo</button>
      </div>
    }
  `,
  styles: [`
    .demo-aviso { display: flex; align-items: center; justify-content: space-between; gap: var(--esp-3); flex-wrap: wrap;
      padding: var(--esp-2) var(--esp-4); background: var(--tint-aviso); color: var(--color-slate-800);
      font-size: var(--texto-sm); font-weight: var(--peso-semi); border-bottom: 1px solid var(--color-slate-200); }
    .demo-salir { flex: none; padding: var(--esp-1) var(--esp-3); border: 1px solid var(--color-slate-400);
      border-radius: var(--radio-md); background: var(--color-card-light); color: inherit; font: inherit; cursor: pointer; }
    .demo-salir:hover:not(:disabled) { border-color: var(--color-slate-700); }
  `],
})
export class AvisoDelDemoComponent {
  private readonly demo = inject(DemoService);
  readonly activo = signal(this.demo.activo());
  readonly saliendo = signal(false);

  async salir(): Promise<void> {
    this.saliendo.set(true);
    try {
      await this.demo.salir();
    } finally {
      AvisoDelDemoComponent.irAlLogin();
    }
  }

  /** Aparte para que las pruebas lo sustituyan: jsdom no navega. */
  static irAlLogin: () => void = () => location.assign('/login');
}
